import React from 'react';
import styled from 'styled-components';
import { useFocusable, setFocus } from '@noriginmedia/norigin-spatial-navigation';

// Mapping des pages vers leurs focusKey
// Note: home n'est pas inclus car la page n'a pas d'éléments focusables
const pageFocusKeys = {
  contacts: 'CONTACTS_MAIN',
  photos: 'PHOTOS_MAIN',
  appels: 'VIDEO_CALL_CONTROLS',
  account: 'ACCOUNT_PAGE',
  messages: 'MESSAGES_PAGE'
};

const SidebarLink = styled.div`
  display: flex;
  color: #fff;
  justify-content: space-between;
  align-items: center;
  padding: 16px 12px;
  list-style: none;
  height: 55px;
  text-decoration: none;
  font-size: 15px;
  transition: all 0.2s ease;

  &:hover, &.tv-focused {
    background: #252831;
    border-left: 4px solid #632ce4;
    cursor: pointer;
  }

  &.tv-focused {
    outline: none;
    box-shadow: inset 0 0 0 2px #632ce4;
  }

  svg {
    font-size: 16px;
    min-width: 16px;
  }

  @media (max-width: 768px) {
    padding: 20px 24px;
    height: 70px;
    font-size: 20px;

    svg {
      font-size: 20px;
      min-width: 20px;
    }

    &:active {
      background: #252831;
      border-left: 4px solid #632ce4;
    }
  }
`;

const SubMenu = ({ item, setCurrentPage, toggleSidebar }) => {
  const isMobile = () => window.innerWidth <= 768;

  const handleNavigate = () => {
    setCurrentPage(item.path);
    if (isMobile()) {
      // Sur mobile, fermer la sidebar
      if (toggleSidebar) {
        toggleSidebar();
      }
    } else {
      // Sur desktop, transférer le focus vers la page après un délai
      const focusKey = pageFocusKeys[item.path];
      if (focusKey) {
        setTimeout(() => {
          setFocus(focusKey);
        }, 300);
      }
    }
  };

  const { ref, focused } = useFocusable({
    onEnterPress: handleNavigate
  });

  return (
    <SidebarLink
      ref={ref}
      className={focused ? 'tv-focused' : ''}
      onClick={handleNavigate}
    >
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {item.icon}
        <span style={{ marginLeft: '10px' }}>{item.title}</span>
      </div>
    </SidebarLink>
  );
};

export default SubMenu;